import React from 'react'
import Header from '../Components/Header/Header'
import Loading from '../Components/Loading/Loading'

function LoadingForAll(props) {
  return (
    <div>
        
        <Loading title={props.title}></Loading>
    </div>
  )
}

export default LoadingForAll